




import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const initialFieldValues = {
    serviceTypeId: '00000000-0000-0000-0000-000000000000',
    salonId: '',
    name: '',
    durationMinutes: 30,
    price: 0,
    category: '',
    isActive: true
};

const Services = () => {
    const [lists, setLists] = useState([]);
    const [categories, setCategories] = useState([]); 
    const [salons, setSalons] = useState([]); 
    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const [showSalonModal, setShowSalonModal] = useState(false);
    const [viewingSalon, setViewingSalon] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [values, setValues] = useState(initialFieldValues);

    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    useEffect(() => {
        GetData();
        GetCategories();
        GetSalons();
    }, []);

    const GetData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${config.APIACTIVEURL}${config.GETSERVICETYPE}`, {
                params: { pageSize: 100, pageNumber: 1 }
            });
            const data = res.data.data || res.data.items || res.data;
            setLists(Array.isArray(data) ? data : []);
        } catch (error) { console.error(error); }
        finally { setLoading(false); }
    };

    const GetCategories = async () => {
        try {
            const res = await axios.get(`${config.APIACTIVEURL}${config.GETALLCATEGORIES}`);
            setCategories(res.data || []);
        } catch (error) { console.error(error); }
    };

    const GetSalons = async () => {
        try {
            const res = await axios.get(`${config.APIACTIVEURL}Salon/GetAll`);
            setSalons(res.data || []);
        } catch (error) { console.error(error); }
    };

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        setValues({ ...values, [name]: type === 'checkbox' ? checked : value });
    };

    const showSalonInfo = (salon) => {
        setViewingSalon(salon);
        setShowSalonModal(true);
    };
    
    const formatCurrency = (amount) => {
        return `${currency} ${amount?.toFixed(2) || '0.00'}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBtnLoading(true);
        try {
            const isNew = values.serviceTypeId === "00000000-0000-0000-0000-000000000000";
            if (isNew) {
                await axios.post(`${config.APIACTIVEURL}${config.CREATESERVICETYPE}`, values);
            } else {
                await axios.put(`${config.APIACTIVEURL}${config.UPDATESERVICETYPE}`, values);
            }
            setShowModal(false);
            GetData();
        } catch (error) { 
            alert(error.response?.data?.message || "Error saving service");
        }
        finally { setBtnLoading(false); }
    };

    const handleDelete = async () => {
        setBtnLoading(true);
        try {
            const url = `${config.APIACTIVEURL}${config.DELETESERVICETYPE}/${itemToDelete}`;
            await axios.delete(url);
            setShowDeleteModal(false);
            GetData();
        } catch (error) { 
            console.error("Delete Error Details:", error);
            const serverMessage = error.response?.data?.message;
            if (serverMessage) {
                alert(`Cannot delete: ${serverMessage}`);
            } else {
                alert("Cannot delete this service because it is linked to existing Appointments. Try deactivating it instead.");
            }
        }
        finally { setBtnLoading(false); }
    };

    return (
        <div className="page-content" style={{ paddingTop: "80px" }}>
            <div className="container-fluid py-4">
                <div className="card border-0 shadow-sm rounded-4">
                    <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <h4 className="fw-bold mb-0" style={{ color: '#064e3b' }}>Services</h4>
                        <button className="btn text-white fw-bold px-4 shadow-sm"
                            style={{ backgroundColor: THEME_COLOR }}
                            onClick={() => { setValues(initialFieldValues); setShowModal(true); }}>
                            <i className="ri-add-line me-1"></i> Add Service
                        </button>
                    </div>

                    <div className="card-body">
                        {loading ? (
                            <div className="text-center py-5"><Spinner animation="border" variant="success" /></div>
                        ) : (
                            <>
                                {/* --- WEB VIEW: TABLE --- */}
                                <div className="table-responsive d-none d-md-block">
                                    <table className="table table-hover align-middle">
                                        <thead className="table-light">
                                            <tr className="text-secondary small text-uppercase text-center">
                                                <th className="text-start">Service Name</th>
                                                <th>Salon</th>
                                                <th>Category</th>
                                                <th>Duration</th>
                                                <th>Price</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lists.map((item) => (
                                                <tr key={item.serviceTypeId} className="text-center">
                                                    <td className="fw-bold text-dark text-start">{item.name}</td>
                                                    <td>
                                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                                            <span>{item.salon?.name || 'N/A'}</span>
                                                            <button 
                                                                className="btn btn-light btn-sm border shadow-sm p-0" 
                                                                style={{ width: '28px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px' }}
                                                                onClick={() => showSalonInfo(item.salon)}>
                                                                <i className="ri-more-2-fill text-muted" style={{ fontSize: '14px' }}></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td><span className="badge bg-light text-dark border px-3">{item.category}</span></td>
                                                    <td>{item.durationMinutes} min</td>
                                                    <td className="fw-bold text-success">{formatCurrency(item.price)}</td>
                                                    <td>
                                                        <button className="btn btn-sm btn-outline-primary border-0 me-2" onClick={() => { setValues(item); setShowModal(true); }}>
                                                            <i className="ri-pencil-line"></i>
                                                        </button>
                                                        <button className="btn btn-sm btn-outline-danger border-0" onClick={() => { setItemToDelete(item.serviceTypeId); setShowDeleteModal(true); }}>
                                                            <i className="ri-delete-bin-line"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* --- MOBILE VIEW: CARDS --- */}
                                <div className="d-md-none">
                                    {lists.map((item) => (
                                        <div key={item.serviceTypeId} className="card border shadow-sm rounded-3 mb-3">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <div>
                                                        <h6 className="fw-bold mb-0 text-dark">{item.name}</h6>
                                                        <small className="text-muted">{item.category}</small>
                                                    </div>
                                                    <div className="fw-bold text-success">
                                                        {formatCurrency(item.price)}
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between bg-light p-2 rounded-2 mb-3">
                                                    <div className="small">
                                                        <i className="ri-building-line me-1"></i> {item.salon?.name || 'N/A'}
                                                        <button 
                                                            className="btn btn-sm p-0 ms-1"
                                                            onClick={() => showSalonInfo(item.salon)}>
                                                            <i className="ri-information-line text-primary"></i>
                                                        </button>
                                                    </div>
                                                    <div className="small">
                                                        <i className="ri-time-line me-1"></i> {item.durationMinutes} min
                                                    </div>
                                                </div>
                                                <div className="d-flex gap-2">
                                                    <button className="btn btn-sm flex-fill btn-outline-primary" onClick={() => { setValues(item); setShowModal(true); }}>
                                                        <i className="ri-pencil-line me-1"></i> Edit
                                                    </button>
                                                    <button className="btn btn-sm flex-fill btn-outline-danger" onClick={() => { setItemToDelete(item.serviceTypeId); setShowDeleteModal(true); }}>
                                                        <i className="ri-delete-bin-line me-1"></i> Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <Modal show={showSalonModal} onHide={() => setShowSalonModal(false)} size="lg" centered>
                    <Modal.Header closeButton className="border-0">
                        <Modal.Title className="fw-bold" style={{ color: THEME_COLOR }}>
                            Salon Profile: {viewingSalon?.name}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4 py-4">
                        {viewingSalon ? (
                            <div className="row g-4 text-center">
                                <div className="col-md-4 col-12">
                                    <small className="text-muted d-block fw-bold text-uppercase mb-1">Phone</small>
                                    <p className="mb-0 text-dark fw-bold">{viewingSalon.phone}</p>
                                </div>
                                <div className="col-md-4 col-12">
                                    <small className="text-muted d-block fw-bold text-uppercase mb-1">Email</small>
                                    <p className="mb-0 text-dark fw-bold" style={{ wordBreak: 'break-all' }}>{viewingSalon.email}</p>
                                </div>
                                <div className="col-md-4 col-12">
                                    <small className="text-muted d-block fw-bold text-uppercase mb-1">Address</small>
                                    <p className="mb-0 text-dark fw-bold">{viewingSalon.address}</p>
                                </div>
                            </div>
                        ) : <p className="text-center">No salon data available</p>}
                    </Modal.Body>
                </Modal>

                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
                    <Modal.Header closeButton><Modal.Title className="fw-bold">Service Details</Modal.Title></Modal.Header>
                    <Modal.Body className="px-4 py-3">
                        <form className="row g-3" onSubmit={handleSubmit}>
                            <div className="col-md-6 col-12">
                                <label className="form-label small fw-bold">Select Salon</label>
                                <select name="salonId" value={values.salonId} onChange={handleInput} className="form-select" required>
                                    <option value="">-- Choose Salon --</option>
                                    {salons.map(s => <option key={s.salonId} value={s.salonId}>{s.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-6 col-12">
                                <label className="form-label small fw-bold">Service Name</label>
                                <input type="text" name="name" value={values.name} onChange={handleInput} className="form-control" required />
                            </div>
                            <div className="col-md-6 col-12">
                                <label className="form-label small fw-bold">Category</label>
                                <select name="category" value={values.category} onChange={handleInput} className="form-select" required>
                                    <option value="">-- Choose Category --</option>
                                    {categories.map(c => <option key={c.categoryId} value={c.name}>{c.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-3 col-6">
                                <label className="form-label small fw-bold">Duration (Min)</label>
                                <input type="number" name="durationMinutes" value={values.durationMinutes} onChange={handleInput} className="form-control" />
                            </div>
                            <div className="col-md-3 col-6">
                                <label className="form-label small fw-bold">Price ({currency})</label>
                                <input type="number" step="0.01" name="price" value={values.price} onChange={handleInput} className="form-control" />
                            </div>
                            <div className="modal-footer border-0 p-0 mt-4">
                                <Button variant="light" onClick={() => setShowModal(false)}>Cancel</Button>
                                <Button type="submit" disabled={btnLoading} style={{ backgroundColor: THEME_COLOR }} className="text-white px-4 border-0 shadow-sm">
                                    {btnLoading ? <Spinner size="sm" /> : 'Save Service'}
                                </Button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>

                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                    <Modal.Header closeButton><Modal.Title className="text-danger fw-bold">Remove Service</Modal.Title></Modal.Header>
                    <Modal.Body>Are you sure you want to delete this service entry?</Modal.Body>
                    <Modal.Footer className="border-0">
                        <Button variant="light" onClick={() => setShowDeleteModal(false)}>No, Keep it</Button>
                        <Button variant="danger" onClick={handleDelete} disabled={btnLoading}>
                            {btnLoading ? <Spinner size="sm" /> : 'Yes, Delete'}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default Services;